import { Console } from "console";
import { getConnectionPool } from "../../core/connectionPool";
import { checkMigrate } from "../../init/sdkInit";
import { request, response } from "../../proto/bundle";
// import { stat } from "fs";
import Long from "long";
import { Organization } from "../userOps/orgnization";
export class StoragePlan {
  private planId!:number ;
  private type!: string;
  private price!: number|Long;
  private maxTeams!: number|Long;
  private maxVersions!: number|Long;
  private maxRoles!: number|Long;
  private maxLogAnalysis!: number|Long;
  private storage!: number|Long;
  private maxSpaces!: number|Long;
  private maxFlows!: number|Long;
  private maxFlowTypes!: number|Long;
  private minUsers!: number|Long;
  private perUserCost!: number|Long;
  private perGbCost!: number|Long;
  private maxPins!: number|Long;
  private maxAlerts!: number|Long;
  private trash!: number|Long;
  private logsHistory!: number|Long;
  private autoAddUsers!: boolean;
  private autoAddStorage!: boolean;
  private  maxTags!: number|Long;
  private name:string;
  private redundancy!: string;
  private support!: string;
  private ransomwareProtection!: boolean;
  private collaboration!: boolean;
  private internalSharing!: boolean;
  private tagBasedAnalysis!: boolean;
  private advancedSpaceFeatures!: boolean;
  private complianceReports!: boolean;
  private geoLocationBasedAlerts!: boolean;
  private dedicatedCluster!: boolean;
  private maxDevices!: number;
  private parallelEdits!: number;
  private docsAndSheets!: boolean;
  setType(type: string): void {
    this.type = type;
  }

  getType(): string {
    return this.type;
  }

  setPrice(price: number|Long): void {
    this.price = price;
  }

  getPrice(): number|Long {
    return this.price;
  }

  setMaxTeams(value: number|Long): void {
    this.maxTeams = value;
  }

  getMaxTeams(): number|Long {
    return this.maxTeams;
  }

  setMaxRoles(value: number|Long): void {
    this.maxRoles = value;
  }

  getMaxRoles(): number|Long {
    return this.maxRoles;
  }

  setMaxLogAnalysis(value: number|Long): void {
    this.maxLogAnalysis = value;
  }

  getMaxLogAnalysis(): number|Long {
    return this.maxLogAnalysis;
  }

  setStorage(value: number|Long): void {
    this.storage = value;
  }

  getStorage(): number|Long {
    return this.storage;
  }

  /** Convert storage bytes (number | Long) to numeric GB for calculations. */
  static storageBytesToGb(bytes: number | Long): number {
    const n = typeof bytes === "number" ? bytes : (bytes as Long).toNumber();
    return n / 1024 ** 3;
  }

  /** Convert storage bytes to display string: "X GB", "X TB", or "X PB". */
  static formatStorageBytes(bytes: number | Long): string {
    const n = typeof bytes === "number" ? bytes : (bytes as Long).toNumber();
    const gb = 1024 ** 3;
    const tb = 1024 ** 4;
    const pb = 1024 ** 5;
    if (n >= pb) return `${Math.round((n / pb) * 100) / 100} PB`;
    if (n >= tb) return `${Math.round((n / tb) * 100) / 100} TB`;
    return `${Math.round((n / gb) * 100) / 100} GB`;
  }

  getname(): string {
    return this.name;
  }

  getMaxVersions(): number|Long {
    return this.maxVersions;
  }
  setMaxVersions(value: number|Long): void {
    this.maxVersions = value;
  }

  setName(name:string) {
    this.name=name;
  }
  setMaxSpaces(value: number|Long): void {
    this.maxSpaces = value;
  }

  getMaxSpaces(): number|Long {
    return this.maxSpaces;
  }

  setMaxFlows(value: number|Long): void {
    this.maxFlows = value;
  }

  getMaxFlows(): number|Long {
    return this.maxFlows;
  }

  setMaxFlowTypes(value: number|Long): void {
    this.maxFlowTypes = value;
  }

  getMaxFlowTypes(): number|Long {
    return this.maxFlowTypes;
  }

  setMinUsers(value: number|Long): void {
    this.minUsers = value;
  }

  getMinUsers(): number|Long {
    return this.minUsers;
  }

  setPerUserCost(value: number|Long): void {
    this.perUserCost = value;
  }

  getPerUserCost(): number|Long {
    return this.perUserCost;
  }

  setPerGbCost(value: number|Long): void {
    this.perGbCost = value;
  }

  getPerGbCost(): number|Long {
    return this.perGbCost;
  }

  setMaxPins(value: number|Long): void {
    this.maxPins = value;
  }

  getMaxPins(): number|Long {
    return this.maxPins;
  }

  setMaxAlerts(value: number|Long): void {
    this.maxAlerts = value;
  }

  getMaxAlerts(): number|Long {
    return this.maxAlerts;
  }

  setTrash(value: number|Long): void {
    this.trash = value;
  }

  getTrash(): number|Long {
    return this.trash;
  }

  setLogsHistory(value: number|Long): void {
    this.logsHistory = value;
  }

  getLogsHistory(): number|Long {
    return this.logsHistory;
  }

  setAutoAddUsers(value: boolean): void {
    this.autoAddUsers = value;
  }

  getAutoAddUsers(): boolean {
    return this.autoAddUsers;
  }

  setAutoAddStorage(value: boolean): void {
    this.autoAddStorage = value;
  }

  getAutoAddStorage(): boolean {
    return this.autoAddStorage;
  }

  getTags(): Long | number {
    return this.maxTags;
  }
  setTags(tags :Long | number){
    this.maxTags=tags;
  }
  getPlanId(): number {
    return this.planId;
  }
  setPlanId(planId: number): void {
    this.planId = planId;
  }

    getRedundancy(): string {
    return this.redundancy;
  }

  getSupport(): string {
    return this.support;
  }

  getRansomwareProtection(): boolean {
    return this.ransomwareProtection;
  }

  getCollaboration(): boolean {
    return this.collaboration;
  }

  getInternalSharing(): boolean {
    return this.internalSharing;
  }

  getTagBasedAnalysis(): boolean {
    return this.tagBasedAnalysis;
  }

  getAdvancedSpaceFeatures(): boolean {
    return this.advancedSpaceFeatures;
  }

  getComplianceReports(): boolean {
    return this.complianceReports;
  }

  getGeoLocationBasedAlerts(): boolean {
    return this.geoLocationBasedAlerts;
  }

  getDedicatedCluster(): boolean {
    return this.dedicatedCluster;
  }
  getDocsAndSheets(): boolean {
    return this.docsAndSheets;
  }
  getMaxDevices(): number {
    return this.maxDevices;
  }

  getParallelEdits(): number {
    return this.parallelEdits;
  }


  setRedundancy(redundancy: string): void {
    this.redundancy = redundancy;
  }

  setSupport(support: string): void {
    this.support = support;
  }

  setRansomwareProtection(value: boolean): void {
    this.ransomwareProtection = value;
  }

  setCollaboration(value: boolean): void {
    this.collaboration = value;
  }

  setInternalSharing(value: boolean): void {
    this.internalSharing = value;
  }

  setTagBasedAnalysis(value: boolean): void {
    this.tagBasedAnalysis = value;
  }

  setAdvancedSpaceFeatures(value: boolean): void {
    this.advancedSpaceFeatures = value;
  }

  setComplianceReports(value: boolean): void {
    this.complianceReports = value;
  }

  setGeoLocationBasedAlerts(value: boolean): void {
    this.geoLocationBasedAlerts = value;
  }

  setDedicatedCluster(value: boolean): void {
    this.dedicatedCluster = value;
  }

  setMaxDevices(value: number): void {
    this.maxDevices = value;
  }

  setParallelEdits(value: number): void {
    this.parallelEdits = value;
  }
  setDocsAndSheets(value: boolean): void {
    this.docsAndSheets = value;
  }
  // formStoragePlan(respPlan :response.StoragePlan):StoragePlan{


  //    return plan;
  // }
   async getPlan():Promise<StoragePlan>{
        const pool = await getConnectionPool();
        const req=request.Request.create({
            id:null,
            reqCreateTime:Date.now(),
            getPlan:request.GetPlan.create({
                planId:this.planId
            })
        });
        let resp=await pool.sendAndWait(req);
        if (!resp.getPlan || resp.getPlan.status !== response.Status.SUCCESS) {
            throw new Error(`Failed to get plan(${resp.getPlan?.status})`);
        }
        let respPlan=resp.getPlan.plan;
        const plan=new StoragePlan();
        plan.setAutoAddStorage(respPlan.autoAddStorage);
        plan.setType(respPlan.type);
        plan.setPrice(respPlan.price);
        plan.setMaxTeams(respPlan.maxTeams);
        plan.setMaxRoles(respPlan.maxRoles);
        plan.setMaxLogAnalysis(respPlan.maxLogAnalysis);
        plan.setStorage(respPlan.storage);
        plan.setMaxSpaces(respPlan.maxSpaces);
        plan.setMaxFlows(respPlan.maxFlows);
        plan.setMaxFlowTypes(respPlan.maxFlowTypes);
        plan.setMinUsers(respPlan.minUsers);
        plan.setPerUserCost(respPlan.perUserCost);
        plan.setPerGbCost(respPlan.perGbCost);
        plan.setMaxPins(respPlan.maxPins);
        plan.setMaxAlerts(respPlan.maxAlerts);
        plan.setTrash(respPlan.trash);
        plan.setLogsHistory(respPlan.logsHistory);
        plan.setAutoAddUsers(respPlan.autoAddUsers);
        plan.setAutoAddStorage(respPlan.autoAddStorage);
        plan.setTags(respPlan.maxTags);
        plan.setName(respPlan.name);
        plan.setPlanId(respPlan.planId);
        plan.setRedundancy(respPlan.redundancy);
        plan.setSupport(respPlan.support);
        plan.setRansomwareProtection(respPlan.ransomwareProtection)
        plan.setCollaboration(respPlan.collabration);
        plan.setInternalSharing(respPlan.internalSharing);
        plan.setTagBasedAnalysis(respPlan.tagBasedAnalysis);
        plan.setAdvancedSpaceFeatures(respPlan.advacedSpaceFeatures);
        plan.setComplianceReports(respPlan.compilanceReports);
        plan.setGeoLocationBasedAlerts(respPlan.geoLocationBasedAlerts);
        plan.setDedicatedCluster(respPlan.dedicatedCluster);
        plan.setMaxDevices(respPlan.maxDevices);
        plan.setParallelEdits(respPlan.parallelEdits);
        plan.setDocsAndSheets(respPlan.docsAndSheets);
        plan.setMaxVersions(respPlan.maxVersions);
        return plan;
    }

    async listPlans(customer:string):Promise<StoragePlan[]>{
        const pool = await getConnectionPool();
        const req=request.Request.create({
            id:null,
            reqCreateTime:Date.now(),
            listPlans:request.ListPlans.create({
              customer:customer,
            })
        });
        let resp=await pool.sendAndWait(req);
        if (!resp.listPlans || resp.listPlans.status !== response.Status.SUCCESS) {
            throw new Error(`Failed to list plan(${resp.listPlans?.status})`);
        }
        let storage_plans=resp.listPlans.plans;
        let plans:StoragePlan[]=[];
        for(let i=0;i<storage_plans.length;i++){
            const plan=new StoragePlan();
            let respPlan=storage_plans[i];
            // console.log("Plan",plan);
            plan.setAutoAddStorage(respPlan.autoAddStorage);
            plan.setType(respPlan.type);
            plan.setPrice(respPlan.price);
            plan.setMaxTeams(respPlan.maxTeams);
            plan.setMaxRoles(respPlan.maxRoles);
            plan.setMaxLogAnalysis(respPlan.maxLogAnalysis);
            plan.setStorage(respPlan.storage);
            plan.setMaxSpaces(respPlan.maxSpaces);
            plan.setMaxFlows(respPlan.maxFlows);
            plan.setMaxFlowTypes(respPlan.maxFlowTypes);
            plan.setMinUsers(respPlan.minUsers);
            plan.setPerUserCost(respPlan.perUserCost);
            plan.setPerGbCost(respPlan.perGbCost);
            plan.setMaxPins(respPlan.maxPins);
            plan.setMaxAlerts(respPlan.maxAlerts);
            plan.setTrash(respPlan.trash);
            plan.setLogsHistory(respPlan.logsHistory);
            plan.setAutoAddUsers(respPlan.autoAddUsers);
            plan.setAutoAddStorage(respPlan.autoAddStorage);
            plan.setTags(respPlan.maxTags);
            plan.setName(respPlan.name);
            plan.setPlanId(respPlan.planId);
            plan.setRedundancy(respPlan.redundancy);
            plan.setSupport(respPlan.support);
            plan.setRansomwareProtection(respPlan.ransomwareProtection)
            plan.setCollaboration(respPlan.collabration);
            plan.setInternalSharing(respPlan.internalSharing);
            plan.setTagBasedAnalysis(respPlan.tagBasedAnalysis);
            plan.setAdvancedSpaceFeatures(respPlan.advacedSpaceFeatures);
            plan.setComplianceReports(respPlan.compilanceReports);
            plan.setGeoLocationBasedAlerts(respPlan.geoLocationBasedAlerts);
            plan.setDedicatedCluster(respPlan.dedicatedCluster);
            plan.setMaxDevices(respPlan.maxDevices);
            plan.setParallelEdits(respPlan.parallelEdits);
            plan.setDocsAndSheets(respPlan.docsAndSheets);
            plan.setMaxVersions(respPlan.maxVersions);
            // console.log("plan Id",plan.getPlanId());
            plans.push(plan);
        }
        console.log("plans", plans);

      return plans;
    }
  async upgradePlan():Promise<StoragePlan[]>{
        const pool = await getConnectionPool();
        const email=pool.getEmail();
        const req=request.Request.create({
            id:null,
            reqCreateTime:Date.now(),
            upgradePlan:request.UpgradePlan.create({
              email:email,
              // organization:organization,
            })
        });
        let resp=await pool.sendAndWait(req);
        if (!resp.upgradePlan || resp.upgradePlan.status !== response.Status.SUCCESS) {
            throw new Error(`Failed to list plan(${resp.upgradePlan?.status})`);
        }
        let storage_plans=resp.upgradePlan.plans;
        let plans:StoragePlan[]=[];
        for(let i=0;i<storage_plans.length;i++){
            const plan=new StoragePlan();
            let respPlan=storage_plans[i];
            // console.log("Plan",plan);
            plan.setAutoAddStorage(respPlan.autoAddStorage);
            plan.setType(respPlan.type);
            plan.setPrice(respPlan.price);
            plan.setMaxTeams(respPlan.maxTeams);
            plan.setMaxRoles(respPlan.maxRoles);
            plan.setMaxLogAnalysis(respPlan.maxLogAnalysis);
            plan.setStorage(respPlan.storage);
            plan.setMaxSpaces(respPlan.maxSpaces);
            plan.setMaxFlows(respPlan.maxFlows);
            plan.setMaxFlowTypes(respPlan.maxFlowTypes);
            plan.setMinUsers(respPlan.minUsers);
            plan.setPerUserCost(respPlan.perUserCost);
            plan.setPerGbCost(respPlan.perGbCost);
            plan.setMaxPins(respPlan.maxPins);
            plan.setMaxAlerts(respPlan.maxAlerts);
            plan.setTrash(respPlan.trash);
            plan.setLogsHistory(respPlan.logsHistory);
            plan.setAutoAddUsers(respPlan.autoAddUsers);
            plan.setAutoAddStorage(respPlan.autoAddStorage);
            plan.setTags(respPlan.maxTags);
            plan.setName(respPlan.name);
            plan.setPlanId(respPlan.planId);
            plan.setRedundancy(respPlan.redundancy);
            plan.setSupport(respPlan.support);
            plan.setRansomwareProtection(respPlan.ransomwareProtection)
            plan.setCollaboration(respPlan.collabration);
            plan.setInternalSharing(respPlan.internalSharing);
            plan.setTagBasedAnalysis(respPlan.tagBasedAnalysis);
            plan.setAdvancedSpaceFeatures(respPlan.advacedSpaceFeatures);
            plan.setComplianceReports(respPlan.compilanceReports);
            plan.setGeoLocationBasedAlerts(respPlan.geoLocationBasedAlerts);
            plan.setDedicatedCluster(respPlan.dedicatedCluster);
            plan.setMaxDevices(respPlan.maxDevices);
            plan.setParallelEdits(respPlan.parallelEdits);
            plan.setDocsAndSheets(respPlan.docsAndSheets);
            plan.setMaxVersions(respPlan.maxVersions);
            // console.log("plan Id",plan.getPlanId());
            plans.push(plan);
        }
        // Console.console.log();

      return plans;
    }
}
